// Module
var code = "<survey-host></survey-host>";
// Exports
module.exports = code;